import { appConfig } from './config'
import { detectMobilePlatform } from './device'

const platformLabels = {
  ios: 'iOS',
  android: 'Android',
  'huawei-android': '华为安卓',
  'android-apk': 'Android 安装包',
  harmonyos: '鸿蒙',
}

const AUTO_REDIRECT_PLATFORMS = new Set(['ios', 'harmonyos', 'huawei-android'])

export function getDownloadUrl(platform) {
  if (platform === 'huawei-android') {
    return appConfig.downloadUrls.android || ''
  }
  if (platform === 'android-apk') {
    return appConfig.downloadUrls.androidApk || ''
  }
  return appConfig.downloadUrls[platform] || ''
}

export function redirectToStoreIfMobile() {
  const platform = detectMobilePlatform()
  if (appConfig.enableLog) {
    console.info(`[download] detected platform=${platform || 'desktop'}`)
  }
  if (!AUTO_REDIRECT_PLATFORMS.has(platform)) {
    return false
  }

  const url = getDownloadUrl(platform)
  if (!url) {
    if (appConfig.enableLog) {
      console.warn(`[download] 未配置 ${platformLabels[platform]} 下载链接`)
    }
    return false
  }

  window.location.replace(url)
  return true
}

/** 已上架应用商店的手机打开下载页时，自动跳转；其他 Android 留在页面下载安装包 */
export function redirectToAvailableStoreIfNeeded() {
  return redirectToStoreIfMobile()
}

export function redirectToHarmonyOSIfNeeded() {
  return redirectToAvailableStoreIfNeeded()
}

export function openStore(platform) {
  const url = getDownloadUrl(platform)
  if (!url) {
    return
  }
  window.open(url, '_blank', 'noopener,noreferrer')
}
